import {NgModule} from '@angular/core';
import {LicensingExaminationService} from './licensing-examination.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [LicensingExaminationService]
})
export class LicensingExaminationModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/licensingexamination/licensing-examination.module.ts